/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../Common/Navbar";
import { fetchApi } from "../utlis/axios";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";
import Loader from "../animation/Loader.json";
import backArrow from "../assets/back-button.png";
import dropdown from "../assets/dropdown.png";
import { toast } from "react-toastify";
import Pagination from "./Pagination";
import noPropertyIcon from '../assets/no-propert-icon.webp';
import { FamilyForm } from "../RegistrationForms/FamilyForm"; // Adjust path as needed
import { MemberRegistration } from "../RegistrationForms/MemberRegistration";
import { PropertyRegistration } from "../RegistrationForms/PropertyRegistration";
import { FaChevronLeft } from "react-icons/fa";

export const FamilyListingdetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState();
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const { role } = useSelector((state) => state.authSlice.userInfo.user);
  const [members, setMembers] = useState();
  const [isLoading, setIsLoading] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [property, setProperty] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [familydata, setFamilydata] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [memberData, setMemberData] = useState();
  const [selectedView, setSelectedView] = useState("property");
  const [newMemberAddPopup, setNewMemberPopup]=useState(false)
  const [propertAddPopup, setPropertyAddPopup]=useState(false)
  const [familyID, setFamilyID]=useState(null)

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(`family/${id}`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        setData(result?.data);
        console.log("family detail :", result?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log({ error });
      toast.error(error?.response?.data?.detail);
    }
  };

  const fetchFamilyData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(`family_detail/${id}`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result?.status === 200) {
        setMembers(result?.data);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const fetchPropertyData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(`property/?family__id=${id}`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result?.status === 200) {
        setProperty(result?.data);
        console.log("property result :///", result?.data);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchFamilyData();
    fetchPropertyData();
  }, []);

  const handleTableRowClick = (id) => {
    console.log("Clicked on row with data:", id);
    navigate(`/propertylistingdetail/${id}`);
  };

  const viewMember = (id) => {
    console.log("Member id :", id);
    navigate(`/viewmember/${id}`);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  console.log("user Role", role);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleEditSuccess = () => {
    setIsEditing(false);
    fetchData(); 
  };

  const Registrationfrom = (id) => {
    setFamilyID(id)
    setNewMemberPopup(true)
  };

  const RegisterProperty = (id) => {
    setFamilyID(id)
    setPropertyAddPopup(true)
  };

  const handleStatus = async (e) => {
    setData((prev) => ({ ...prev, status: e.target.id }));
    const updatedStatus = e.target.id;
    const data = new FormData();
    data.append("status", updatedStatus);
    try {
      const result = await fetchApi.patch(`family/${id}/`, data, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result?.status === 200) {
        navigate(-1);
      }
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.detail);
    }
  };

  const fetchFamilyMembers = async () => {
    try {
      const result = await fetchApi.get(`member/?family__id=${id}`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result?.status === 200) setMemberData(result?.data);
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    fetchFamilyMembers();
  }, [id]);

  const itemsPerPage = 10;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const totalPages = 1;
  const fetchDataForPage = async (pageNumber) => {
    const newOffset = (pageNumber - 1) * itemsPerPage;

    try {
      const result = await fetchApi.get(
        `property/?limit=${itemsPerPage}&offset=${newOffset}&page=${pageNumber}&pageSize=${itemsPerPage}&search=${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );

      return result;
    } catch (error) {
      throw error;
    }
  };
 

  const handlePageClick = (pageNumber) => {
    console.log("pageNumbber", pageNumber);
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
      setIsLoading(true);

      fetchDataForPage(pageNumber)
        .then((result) => {
          if (result.status === 200) {
            setFamilydata(result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };


  const handleToggleClick = (view) => {
    setSelectedView(view);
  };

  const ViewMemberfunc = (id) => {
    navigate(`/memberlistingdetail/${id}`);
  };

  return (
    <>
      <Header parent={"family"} />
      <div
        style={{ backgroundColor: "#ffffff", minHeight: "100vh" }}
        className="px-[16px] pt-20 pb-4"
      >
        <button
          className="p-1 w-max rounded-circle d-flex align-items-center justify-content-center mb-4 text-white bg-primary-green"
          onClick={handleGoBack}
        >
          <FaChevronLeft size={24}/>
        </button>

        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70vh",
            }}
          >
            <Lottie
              loop={true}
              animationData={Loader}
              style={{ width: "200px" }}
            />
          </div>
        ) : (
          <>
              <div className="max-w-screen-lg mx-auto">
                {/* Profile Header Section */}
                <div className=" sm:p-4 p-2 mb-2 border-b border-gray-border">
                  <div className="flex sm:items-end flex-col md:flex-row">
                    <div className="col-12 col-md-6">
                      <div className="d-flex sm:flex-col flex-row align-items-center gap-3 mb-3 mb-md-0">
                        <img
                          src={require("../assets/woman.png")}
                          alt="profile"
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            border: "3px solid #f0f0f0",
                          }}
                        />
                        <div>
                          <h2
                            className="mb-2"
                            style={{ fontSize: "28px", fontWeight: "600" }}
                          >
                            {data?.name}
                          </h2>
                          <div className="d-flex gap-3">
                            <span className="bg-primary-green/10 text-primary-green py-2 px-3 rounded-full font-semibold text-sm"
                            >
                              Male: {members?.male_members || "03"}
                            </span>
                            <span className="bg-primary-green/10 text-primary-green py-2 px-3 rounded-full font-semibold text-sm"
                            >
                              Female: {members?.female_members || "06"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="flex gap-2 justify-content-md-end">
                        <span
                          className="primary-button"
                          onClick={handleEditClick}
                        >
                          Edit
                        </span>
                        <span
                          className="primary-button"
                          onClick={() => Registrationfrom(data?.id)}
                        >
                          Add Member
                        </span>
                        <span
                          className="primary-button"
                          onClick={() => RegisterProperty(data?.id)}
                        >
                          Add Property
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Main Content Area */}
                <div className="">
                  {/* Application Information */}
                  <div className=" sm:p-4 p-[8px] mb-2 border-b border-gray-border flex items-start gap-[16px]">
                    <h5
                      className="mb-4 w-2/5"
                      style={{ fontWeight: "600", fontSize: "18px" }}
                    >
                      Application Information
                    </h5>

                    <div className=" w-3/5">
                      <div className="w-full border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            Status
                          </p>
                          {role === "admin" ? (
                            <div style={{ position: "relative" }}>
                              <button
                                className="!font-roboto px-3 py-1 border border-primary-green text-primary-green w-max shadow-none font-semibold bg-primary-green/5 rounded-full capitalize flex items-center gap-2 " style={{border:'1px solid #219d80'}}
                                onClick={() => setIsOpen(!isOpen)}
                              >
                                {data?.status}{" "}
                                <img
                                  src={dropdown}
                                  alt="dropdown"
                                  style={{ width: "12px", marginLeft: "5px" }}
                                />
                              </button>
                              <div
                                className="status-dropdown"
                                style={{
                                  opacity: isOpen ? 1 : 0,
                                  visibility: isOpen ? "visible" : "hidden",
                                  position: "absolute",
                                  top: "100%",
                                  left: 0,
                                  marginTop: "5px",
                                  backgroundColor: "white",
                                  borderRadius: "8px",
                                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                                  zIndex: 10,
                                  minWidth: "120px",
                                }}
                              >
                                <p
                                  className="text-capitalize accepted px-3 py-2 m-0"
                                  id="accepted"
                                  onClick={handleStatus}
                                  style={{ cursor: "pointer" }}
                                >
                                  accepted
                                </p>
                                <p
                                  className="text-capitalize rejected px-3 py-2 m-0"
                                  id="rejected"
                                  onClick={handleStatus}
                                  style={{ cursor: "pointer" }}
                                >
                                  rejected
                                </p>
                                <p
                                  className="text-capitalize in-review px-3 py-2 m-0"
                                  id="in-review"
                                  onClick={handleStatus}
                                  style={{ cursor: "pointer" }}
                                >
                                  in-review
                                </p>
                                <p
                                  className="text-capitalize hold px-3 py-2 m-0"
                                  id="hold"
                                  onClick={handleStatus}
                                  style={{ cursor: "pointer" }}
                                >
                                  hold
                                </p>
                              </div>
                            </div>
                          ) : (
                            <span
                              className="d-inline-block px-3 py-1 border-[1px] capitalize border-primary-green font-semibold"
                              style={{ 
                                backgroundColor: "#e0f2f1",
                                color: "#14B8A6",
                                borderRadius: "20px",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              {data?.status}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="w-full border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            Total Members
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {members?.total_members || "10"}
                          </p>
                        </div>
                      </div>

                      <div className="w-full border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            Application Priority
                          </p>
                          <p
                            className="mb-0"
                            style={{
                              fontSize: "16px",
                              fontWeight: "600",
                              textTransform: "capitalize",
                            }}
                          >
                            {data?.application_priority}
                          </p>
                        </div>
                      </div>

                      <div className="w-full ">
                        <div className="">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            Contact Number
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {data?.contact_number || "null"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Household Overview */}
                  <div className="flex items-start gap-[16px] sm:p-4 p-[8px]">
                    <h5
                      className="mb-4 w-2/5"
                      style={{ fontWeight: "600", fontSize: "18px" }}
                    >
                      Household Overview
                    </h5>

                    <div className=" w-3/5">
                      <div className="w-full border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            Village / City
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {data?.village_or_city}
                          </p>
                        </div>
                      </div>

                      <div className="w-full border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            Tahsil
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {data?.tehsil}
                          </p>
                        </div>
                      </div>

                      <div className="w-full border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            District
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {data?.district}
                          </p>
                        </div>
                      </div>

                      <div className="w-full border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            Post Code
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {data?.post_code}
                          </p>
                        </div>
                      </div>

                      <div className="border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            Description
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {data?.description}
                          </p>
                        </div>
                      </div>

                      <div className="border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            Status Statement
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {data?.status_statement}
                          </p>
                        </div>
                      </div>

                      <div className="w-full border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            Father name
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {data?.father_name || "null"}
                          </p>
                        </div>
                      </div>

                      <div className="w-full border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            Mother Name
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {data?.mother_name || "null"}
                          </p>
                        </div>
                      </div>

                      <div className="w-full border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            No. of Sons
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {data?.number_of_sons || "null"}
                          </p>
                        </div>
                      </div>

                      <div className="w-full border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            No. of Daughters
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {data?.number_of_daughters || "null"}
                          </p>
                        </div>
                      </div>

                      <div className="border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            Address
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {data?.address}
                          </p>
                        </div>
                      </div>

                      <div className="border-b border-gray-border">
                        <div className="mb-3">
                          <p
                            className="mb-1"
                            style={{ color: "#666", fontSize: "14px" }}
                          >
                            Pin Location
                          </p>
                          <p
                            className="mb-0"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {data?.pin_location}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Toggle Buttons */}
                <div className="flex justify-center items-center gap-4 rounded-full mx-auto border border-[#444444] px-0.5 py-0.5 bg-[#FCF7F4] w-max md:mb-6 mb-4">
                  <span
                    className={`${selectedView === 'property' ? 'primary-button':  'px-3 py-2'}`}
                    onClick={() => handleToggleClick("property")}
                  >
                    Property
                  </span>
                  <span
                    className={`${selectedView === 'members' ? 'primary-button':  'px-3 py-2'}`}
                    onClick={() => handleToggleClick("members")}
                  >
                    Members
                  </span>
                </div>

                {/* Property or Members Content */}
                {selectedView === "property" ? (
                  <div className="">
                    {property?.results?.length === 0 ? (
                      <div className="bg-[#FCFBF7] rounded-3xl px-4 border border-gray-border flex flex-col items-center gap-1 justify-center md:py-16 py-8">
                        <img src={noPropertyIcon} className="max-w-xs" alt="icon"/>
                      <p className="text-center mt-2" style={{ color: "#666" }}>
                        No property registered for this family.
                      </p>
                      <div className="primary-button">
                        Add Property
                      </div>
                      </div>
                    ) : (
                      <>
                        <div className="overflow-x-auto bg-white rounded-[20px] border border-gray-border">
                          <table className="min-w-full border-collapse">
                            <thead>
                              <tr className="bg-primary-green text-white text-left">
                                <th className="py-[8px] md:py-4 md:px-4 px-2 text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                                  Property Name
                                </th>
                                <th className="py-[8px] md:py-4 md:px-4 px-2 text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                                  Property Type
                                </th>
                                <th className="py-[8px] md:py-4 md:px-4 px-2 text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                                  Worth
                                </th>
                                <th className="py-[8px] md:py-4 md:px-4 px-2 text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                                  Property Since
                                </th>
                                <th className="py-[8px] md:py-4 md:px-4 px-2 text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                                  Family
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {property?.results?.map((data, value) => (
                                <tr
                                  key={value}
                                  className={`cursor-pointer hover:bg-gray-100 ${
                                    value % 2 === 0 ? "bg-white" : "bg-[#219D8014]"
                                  }`}
                                  onClick={() => handleTableRowClick(data?.id)}
                                >
                                  <td className="py-[8px] md:py-4 md:px-4 px-2 text-xs font-normal md:text-base whitespace-nowrap truncate">
                                    {data?.name}
                                  </td>
                                  <td className="py-[8px] md:py-4 md:px-4 px-2 text-xs font-normal md:text-base whitespace-nowrap truncate capitalize">
                                    {data?.type}
                                  </td>
                                  <td className="py-[8px] md:py-4 md:px-4 px-2 text-xs font-normal md:text-base whitespace-nowrap truncate">
                                    {data?.worth}
                                  </td>
                                  <td className="py-[8px] md:py-4 md:px-4 px-2 text-xs font-normal md:text-base whitespace-nowrap truncate">
                                    {data?.owned_since}
                                  </td>
                                  <td className="py-[8px] md:py-4 md:px-4 px-2 text-xs font-normal md:text-base whitespace-nowrap truncate">
                                    {data?.family?.name}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination */}
          <div className="flex justify-center items-center mt-6">
            <Pagination
              currentPage={currentPage}
              handlePageClick={handlePageClick}
              totalPages={totalPages}
            />
          </div>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="bg-[#FCFBF7] rounded-3xl sm:p-4 p-2 border border-gray-border grid grid-cols-1 md:grid-cols-2 items-center gap-4 justify-center">
                    {memberData?.results?.length === 0 ? (
                      <p className="text-center py-5" style={{ color: "#666" }}>
                        No members registered for this family.
                      </p>
                    ) : (
                      memberData?.results?.map((item) => (
                        <div className=""
                          key={item?.id}
                        >
                          <div className="bg-white rounded-2xl border border-primary-green sm:p-4 p-2 h-100">
                            <div className="text-center mb-3 items-center justify-center flex flex-col">
                              <img
                                src={require(`../assets/${
                                  item?.gender === "Male" ? "man" : "woman"
                                }.png`)}
                                alt="profile"
                                style={{
                                  width: "80px",
                                  height: "80px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  border: "3px solid #f0f0f0",
                                }}
                              />
                              <span className="text-xl font-bold">{item.first_name}</span>
                              <span className="text-base font-medium"> {item?.cnic_number}</span>
                            </div>

                            <div className="mb-3 border border-gray-border p-3 bg-[#EDF7F5] rounded-2xl">
                              <h4 className="text-sm font-semibold">Detailed user info</h4>
                              <div className="d-flex justify-content-between mb-2">
                                <span
                                  style={{ color: "#666", fontSize: "14px" }}
                                >
                                  Education
                                </span>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                  }}
                                >
                                  {item?.education_or_qualification}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between mb-2">
                                <span
                                  style={{ color: "#666", fontSize: "14px" }}
                                >
                                  Willing to Study
                                </span>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                  }}
                                >
                                  {item?.willing_to_study ? "Yes" : "No"}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between mb-2">
                                <span
                                  style={{ color: "#666", fontSize: "14px" }}
                                >
                                  Permanent Medication
                                </span>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                  }}
                                >
                                  {item?.permanent_medication ? "Yes" : "No"}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between mb-3">
                                <span
                                  style={{ color: "#666", fontSize: "14px" }}
                                >
                                  Age
                                </span>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                  }}
                                >
                                  {item?.age}
                                </span>
                              </div>
                            </div>

                            <div
                              onClick={() => ViewMemberfunc(item?.id)}
                              className="w-full font-quicksand text-center primary-button"
                              style={{width:'100%'}}
                            >
                              View
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>
          </>
        )}
         {isEditing && (
                    <FamilyForm 
                      initialData={data}
                      isEdit={true}
                      familyId={id}
                      onSuccess={handleEditSuccess}
                      setShowModal={setIsEditing}
                      handleSucces={handleEditSuccess}
                    />
            )}
            {
              newMemberAddPopup && <MemberRegistration setShowModal={setNewMemberPopup} familyId={familyID}/>
            }
            {
              propertAddPopup && <PropertyRegistration setShowModal={setPropertyAddPopup} familyId={familyID}/>
            }
      </div>
    </>
  );
};